import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonAdd: {
    id: 'button.label.add',
    defaultMessage: 'Add',
    description: 'Label for adding to a program to an application',
  },
  mtAuditionProgramNote: {
    id: 'schedule.mtAuditionProgramNote',
    defaultMessage: 'To be considered for this program, you must submit your audition material(s) through Additional Materials in MySchools and add the program to your application.',
    description: 'Note for MT audition programs about submitting audition materials',
  },
  talentTestLimitReachedNote: {
    id: 'schedule.talentTestLimitReachedNote',
    defaultMessage: "You can only register and apply to two talent test programs. If you'd like to register and apply to this program, please cancel one of your other talent test registrations.",
    description: 'Note displayed when student has reached the limit of 2 talent test registrations',
  },
  buttonExpressInterest: {
    id: 'button.label.expressInterest',
    defaultMessage: 'Express Interest',
    description: 'The express interest string',
  },
  buttonExpressInterestMSNonAudition: {
    id: 'button.label.expressInterestMS',
    defaultMessage: 'Register for Testing',
    description: 'The express interest string for middle school',
  },
  buttonExpressInterestLaGuardiaCase: {
    id: 'button.label.expressInterestLaGuardiaCase',
    defaultMessage: 'Save Instrument(s)',
    description: 'The saving Instruments Data string',
  },
  buttonCancelRegistration: {
    id: 'button.label.cancelRegistration',
    defaultMessage: 'Cancel registration',
    description: 'The cancel registration string',
  },
  buttonLabelReviewAndSubmit: {
    id: 'button.label.reviewAndSubmit',
    defaultMessage: 'Review and Prepare to Submit',
  },
  buttonNoGoBack: {
    id: 'button.label.noGoBack',
    defaultMessage: 'No, go back.',
    description: 'The go back cancellation string',
  },
  buttonReScheduleCancel: {
    id: 'button.label.reScheduleCancel',
    defaultMessage: 'Reschedule (or cancel)',
    description: 'The re-schedule/cancel string',
  },
  buttonScheduleAppointment: {
    id: 'button.label.scheduleeAppointment',
    defaultMessage: 'Schedule testing',
    description: 'The schedule appointment string',
  },
  buttonSubmitRegistration: {
    id: 'button.label.submitRegistration',
    defaultMessage: 'Submit Registration',
    description: 'The program register submit string',
  },
  buttonSubmitMSRegistration: {
    id: 'button.label.submitMSRegistration',
    defaultMessage: 'Register for this Talent Test',
    description: 'The MS program register submit string',
  },
  buttonSubmitMSRegistrationForAudition: {
    id: 'button.label.buttonSubmitMSRegistrationForAudition',
    defaultMessage: 'Express Interest',
    description: 'The MS program register submit string',
  },
  buttonSubmitLGAInstrumentsData: {
    id: 'button.label.submitLGAInstrumentsData',
    defaultMessage: 'Save Instrument(s)',
    description: 'The save instruments data string',
  },
  buttonUnExpressInterest: {
    id: 'button.label.unExpressInterest',
    defaultMessage: 'Un-Express Interest',
    description: 'The un-express interest string',
  },
  buttonUnExpressInterestMSNonAudition: {
    id: 'button.label.unExpressInterestMS',
    defaultMessage: 'Un-Register for Testing',
    description: 'The un-express interest string',
  },
  buttonUnExpressInterestMSForAudition: {
    id: 'button.label.buttonUnExpressInterestMSForAudition',
    defaultMessage: 'Withdraw Interest',
    description: 'The un-express interest string',
  },
  buttonUnExpressInterestLaGuardiaCase: {
    id: 'button.label.unExpressInterestLaGuardiaCase',
    defaultMessage: 'Cancel Audition',
    description: 'The cancel audition string',
  },
  buttonYesCancel: {
    id: 'button.label.yesCancel',
    defaultMessage: 'Yes, cancel',
    description: 'The cancel confirmation string',
  },
  buttonYesRemove: {
    id: 'button.label.yesRemove',
    defaultMessage: 'Yes, remove',
    description: 'The removal confirmation string',
  },
  buttonSearch: {
    id: 'button.label.search',
    defaultMessage: 'Search',
    description: 'Search button',
  },
  buttonClearSearch: {
    id: 'button.label.clearSearch',
    defaultMessage: 'Clear Search',
    description: 'Search clear button',
  },
  buttonStudentEligibleInfo: {
    id: 'button.label.studentEligibleInfo',
    defaultMessage: 'Eligible info',
    description: 'Student eligible info button',
  },
  buttonStudentNotEligibleInfo: {
    id: 'button.label.studentNotEligibleInfo',
    defaultMessage: 'Not eligible info',
    description: 'Student not eligible info button',
  },
  buttonZonedProgramInfo: {
    id: 'button.label.zonedProgramInfo',
    defaultMessage: 'Zoned program info',
    description: 'Zoned program info button',
  },
  buttonSchoolsSearchNext: {
    id: 'button.label.schoolSearchNext',
    defaultMessage: 'Next',
    description: 'Next button',
  },
  buttonSchoolsSearchPrevious: {
    id: 'button.label.schoolSearchPrevious',
    defaultMessage: 'Previous',
    description: 'Previous button',
  },
  iconMapPin: {
    id: 'icon.label.MapPin',
    defaultMessage: 'Map pin',
    description: 'Map pin icon',
  },
  iconCursor: {
    id: 'icon.label.Cursor',
    defaultMessage: 'Cursor',
    description: 'Cursor icon',
  },
  iconEmail: {
    id: 'icon.label.Email',
    defaultMessage: 'Email',
    description: 'Email icon',
  },
  iconPhone: {
    id: 'icon.label.Phone',
    defaultMessage: 'Phone',
    description: 'Phone icon',
  },
  iconContactName: {
    id: 'icon.label.ContactName',
    defaultMessage: 'Contact Name',
    description: 'Contact Name icon',
  },
  iconMortarboard: {
    id: 'icon.label.Mortarboard',
    defaultMessage: 'Mortarboard',
    description: 'Mortarboard icon',
  },
  iconStudents: {
    id: 'icon.label.Students',
    defaultMessage: 'Students',
    description: 'Students icon',
  },
  iconTime: {
    id: 'icon.label.Time',
    defaultMessage: 'Time',
    description: 'Time icon',
  },
  iconSubway: {
    id: 'icon.label.Subway',
    defaultMessage: 'Subway',
    description: 'Subway icon',
  },
  iconBus: {
    id: 'icon.label.Bus',
    defaultMessage: 'Bus',
    description: 'Bus icon',
  },
  generalStringAddToApplication: {
    id: 'generalString.addToApplication',
    defaultMessage: 'Add to Application',
    description: 'The add to application string',
  },
  generalStringAddToApplicationTooltip: {
    id: 'generalString.addToApplicationTooltip',
    defaultMessage:
      'You can add programs directly to your application, but if you’re just considering it, click the star to add it to your favorites for later review!',
    description: 'The tooltip for adding a program to an application from school details page',
  },
  generalStringAddMTD21ToApplicationTooltip: {
    id: 'generalString.addMTD21ToApplicationTooltip',
    defaultMessage:
      'This program requires you to submit a Request for Testing. Visit the Register for Mark Twain/D21 tab for instructions.',
    description: 'This program requires you to submit a Request for Testing. Visit the Register for Mark Twain/D21 tab for instructions.',
  },
  generalStringRemoveFromApplication: {
    id: 'generalString.RemoveFromApplication',
    defaultMessage: 'Remove from Application',
    description: 'The remove from application string',
  },
  generalStringMandatoryInstrumentLaGuardia: {
    id: 'generalString.mandatoryInstrumentLaGuardia',
    defaultMessage: 'You must select the primary instrument in order to apply.',
    description: 'The instruments title string',
  },
  generalStringPrimaryInstrumentLaGuardia: {
    id: 'generalString.primaryInstrumentLaGuardia',
    defaultMessage: 'Primary (Mandatory):',
    description: 'The primary instrument string',
  },
  selectInstrumentOption: {
    id: 'schedule.SelectOption',
    defaultMessage: 'Select',
    description: 'Default option string for dropdowns',
  },
  generalStringSecondaryInstrumentLaGuardia: {
    id: 'generalString.secondaryInstrumentLaGuardia',
    defaultMessage: 'Secondary (Optional):',
    description: 'The secondary instrument string',
  },
  generalStringSaveInstrumentsLaGuardia: {
    id: 'generalString.saveInstrumentsLaGuardia',
    defaultMessage: 'Save Instrument(s)',
    description: 'The save instruments string',
  },
  generalStringAddWaitlist: {
    id: 'generalString.addWaitlist',
    defaultMessage: 'Join Waitlist',
    description: 'The join waitlist string',
  },
  generalStringAddWaitlistTooltip: {
    id: 'generalString.addWaitlistTooltip',
    defaultMessage:
      'You can join the waitlist for a program you are eligible for. Some schools require you to answer questions before joining, which will display once you click here.',
    description: 'The tooltip for adding a program to an application from school details page',
  },
  generalStringRemoveFromWaitlist: {
    id: 'generalString.removeFromWaitlist',
    defaultMessage: "Remove from Waitlist",
    description: 'Title for alert box that appears while removing from waitlist',
  },
  generalStringAddToCalendar: {
    id: 'generalString.addToCalendar',
    defaultMessage: 'Add to Calendar',
    description: 'The add to calendar string',
  },
  generalStringAdmissionMethod: {
    id: 'generalString.admissionMethod',
    defaultMessage: 'Admission Method',
    description: 'The admission method string',
  },
  generalStringBack: {
    id: 'generalString.back',
    defaultMessage: 'Back',
    description: 'The back string',
  },
  generalStringBackToList: {
    id: 'generalString.backToList',
    defaultMessage: 'Back to List',
    description: 'The back to list string',
  },
  generalStringBackToMap: {
    id: 'generalString.backToMap',
    defaultMessage: 'Back to Map',
    description: 'The back to map string',
  },
  generalStringConflict: {
    id: 'generalString.conflict',
    defaultMessage: 'Conflict',
    description: 'The conflict string',
  },
  generalStringExpandSection: {
    id: 'generalString.expandSection',
    defaultMessage: 'Expand section',
    description: 'The expand section string',
  },
  generalStringExpandedSection: {
    id: 'generalString.expandedSection',
    defaultMessage: 'Expanded section',
    description: 'The expanded section string',
  },
  generalStringLikelihoodOfAnOffer: {
    id: 'generalString.likelihoodOfAnOffer',
    defaultMessage: 'Likelihood of an offer',
    description: 'The likelihood of an offer string',
  },
  generalStringNext: {
    id: 'generalString.next',
    defaultMessage: 'Next',
    description: 'The next string',
  },
  generalStringNotKnownYet: {
    id: 'generalString.notKnownYet',
    defaultMessage: 'Not known yet',
    description: 'The not known yet string',
  },
  generalStringPerformance: {
    id: 'generalString.performance',
    defaultMessage: 'Performance',
    description: 'The performance string',
  },
  generalStringSave: {
    id: 'generalString.save',
    defaultMessage: 'Save',
    description: 'The save string',
  },
  generalStringSaved: {
    id: 'generalString.saved',
    defaultMessage: 'Saved',
    description: 'The saved string',
  },
  generalStringSavedPrograms: {
    id: 'generalString.savedPrograms',
    defaultMessage: 'Favorite Programs',
    description: 'A list of currently favorite programs',
  },
  generalStringSearchAllSchoolsAndPrograms: {
    id: 'generalString.searchAllSchoolsAndPrograms',
    defaultMessage: 'Search All Schools & Programs',
    description: 'Header string for Logged In Page',
  },
  generalStringSearchAllPrograms: {
    id: 'generalString.searchAllPrograms',
    defaultMessage: 'Search All Programs',
    description: 'Header string for search field for 3K & Pre-Kindergarten',
  },
  generalStringYourSavedPrograms: {
    id: 'generalString.yourSavedPrograms',
    defaultMessage: 'Your Favorite Programs',
    description: 'Header string for Favorite Page',
  },
  generalStringSchedule: {
    id: 'generalString.schedule',
    defaultMessage: 'Schedule',
    description: 'The schedule string',
  },
  generalStringScheduleDeadline: {
    id: 'generalString.scheduleDeadline',
    defaultMessage: 'Schedule Deadline',
    description: 'The schedule deadline string',
  },
  generalStringScheduleList: {
    id: 'generalString.scheduleList',
    defaultMessage: 'Schedule List',
    description: 'The schedule list string',
  },
  generalStringScheduled: {
    id: 'generalString.scheduled',
    defaultMessage: 'Scheduled',
    description: 'The scheduled string',
  },
  generalStringSeeAllScreenedPrograms: {
    id: 'generalString.seeAllScreenedPrograms',
    defaultMessage: 'See All Screened Programs',
    description: 'The see all screened programs string',
  },
  generalStringShare: {
    id: 'generalString.share',
    defaultMessage: 'Share',
    description: 'The share string',
  },
  generalStringSomethingWentWrong: {
    id: 'generalString.somethingWentWrong',
    defaultMessage: 'We’re sorry, there was an error. Please try again or visit Help to find contact information.',
    description: 'String used when something goes wrong',
  },
  generalStringSorry: {
    id: 'generalString.sorry',
    defaultMessage: 'Sorry',
    description: 'Sorry string',
  },
  generalStringSubmitEdits: {
    id: 'generalString.SubmitEdits',
    defaultMessage: 'Submit Edits',
    description: 'The submit edits text',
  },
  generalStringApplicantsPerSeat: {
    id: 'generalString.applicantsPerSeat',
    defaultMessage: 'applicants per seat',
    description: 'number of applicants per seat',
  },
  generalStringApplicantsPerSeatLastYear: {
    id: 'generalString.applicantsPerSeatLastYear',
    defaultMessage: 'applicants per seat last year',
    description: 'number of applicants per seat',
  },
  generalStringPriorityGroup: {
    id: 'generalString.priorityGroup',
    defaultMessage: 'admissions priorities',
    description: 'which priority group you belong to',
  },
  generalStringToolTipPriorityGroup: {
    id: 'generalString.ToolTipPriorityGroup',
    defaultMessage: 'YOUR PRIORITY GROUP',
    description: 'which priority group you belong to',
  },
  generalStringProgramNeedsAssessment: {
    id: 'generalString.ProgramNeedsAssessment',
    defaultMessage: `This program requires an assessment for admissions. Visit the "Schedule" step to set it up.`,
    description: `Message shown if a program has no scheduling data`,
  },
  generalStringStudentNotEligibleForProgram: {
    id: 'generalString.StudentNotEligibleForProgram',
    defaultMessage: `{firstName} is not eligible for this program.`,
    description: `Subheader shown if a student is not eligible for a program`,
    values: {
      firstName: 'Your child',
    },
  },
  generalStringStudentNotEligible: {
    id: 'generalString.StudentNotEligible',
    defaultMessage: `{firstName} is not eligible for this program. Open the program's details for eligibility info.`,
    description: `Message shown if a student is not eligible for a program`,
    values: {
      firstName: 'Your child',
    },
  },
  generalStringProgramHasAppointment: {
    id: 'generalString.ProgramHasAppointment',
    defaultMessage: `This program already has an appointment scheduled.`,
    description: `Message shown if a student already has an appointment scheduled.`,
  },
  generalStringProgramHasDifferentAdmissionProcess: {
    id: 'generalString.ProgramHasDifferentAdmissionProcess',
    defaultMessage: `This program must be applied to in the {admissionProcess} application, which can be found on your Dashboard.`,
    description: `Message shown if the program belongs to a different admission process`,
    values: {
      admissionProcess: '',
    },
  },
  generalStringStudentNotEligibleHelp: {
    id: 'generalString.StudentNotEligibleHelp',
    defaultMessage: `If you believe this is an error, visit the Help section for contact information.`,
    description: `Additional message shown if a student is not eligible for a program`,
  },
  searchfieldPlaceholderSavedPrograms: {
    id: 'searchfield.placeholder.savedPrograms',
    defaultMessage: 'Search your favorites',
    description: 'Placeholder for favorite program search',
  },
  searchfieldPlaceholderSchools: {
    id: 'searchfield.placeholder.schools',
    defaultMessage: 'Search by school name, interests, etc.',
    description: 'Placeholder for searching for schools',
  },
  searchfieldPlaceholderSchoolsForPKAnd3K: {
    id: 'searchfield.placeholder.schools.pk.3k',
    defaultMessage: 'Search by provider name, interests, etc.',
    description: 'Placeholder for searching for schools for PK and 3K',
  },
  generalStringZoned: {
    id: 'generalString.zoned',
    defaultMessage: 'Zoned',
    description: 'Zoned string',
  },
  generalStringNoResultsFound: {
    id: 'generalString.noResultsFound',
    defaultMessage: 'No results found',
    description: 'No Results Found string',
  },
  generalStringTest: {
    id: 'generalString.test',
    defaultMessage: 'Test',
    description: 'The test (assessment context) string',
  },
  generalStringAccessibilityInfo: {
    id: 'generelString.accessibilityInfo',
    defaultMessage: 'Accessibility info for school: {schoolName}',
    description: 'String used to describe accessibility info icon',
  },
  generalStringSearch: {
    id: 'generalString.search',
    defaultMessage: 'Search',
    description: 'General label for search input',
  },
  generalStringAddress: {
    id: 'generalString.address',
    defaultMessage: 'Address',
    description: 'General label for address search input',
  },
  generalStringYourChildsAddress: {
    id: 'generalString.yourChildsAddress',
    defaultMessage: `Your Child's Address`,
    description: 'General label for address search input',
  },
  generalStringDistanceFromHome: {
    id: 'generalString.distanceFromHome',
    defaultMessage: 'Distance from home',
    description: 'String used to describe subway icon',
  },
  generalStringGradeRange: {
    id: 'generalString.gradeRange',
    defaultMessage: 'Grade range',
    description: 'String used to describe mortarboard icon',
  },
  schoolProgramToolTipTopTitle: {
    id: 'schoolProgram.ToolTipTitle',
    defaultMessage: 'MY CHANCES',
    description: 'advice for programs saving',
  },
  schoolProgramToolTipTopParagraph: {
    id: 'schoolProgram.ToolTipTopParagraph',
    defaultMessage: `Your chances of an offer are a combination of the number of <strong>applicants per seat</strong> last year and your <strong>priority  group</strong> for this program:`,
    description: 'advice for programs saving',
  },
  schoolProgramToolTipTopParagraphGT: {
    id: 'schoolProgram.ToolTipTopParagraphGT',
    defaultMessage: `Your chances of an offer are a combination of the number of <strong>applicants per seat</strong> and your <strong>priority group</strong> for this program.`,
    description: 'advice for programs saving GT',
  },
  schoolProgramToolTipLikelihoodFirstParagraph: {
    id: 'schoolProgram.ToolTipLikelihoodFirstParagraph',
    defaultMessage: `Some programs have additional eligibility and selection criteria. See My Chances in the program’s details for more info.`,
    description: 'advice for programs saving',
  },
  schoolProgramToolTipLikelihoodLastParagraph: {
    id: 'schoolProgram.ToolTipLikelihoodLastParagraph',
    defaultMessage: `Save at least some programs with fewer than 4 applicants per seat, or for which you’re in the top priority group. Later we’ll check to make sure you have a balanced selection of programs in your application, in order to improve your chances of getting an offer in this round.`,
    description: 'advice for programs saving',
  },
  schoolProgramToolTipZoned: {
    id: 'schoolProgram.ToolTipZoned',
    defaultMessage: `{firstName} is guaranteed a seat at this zoned program. Put it below all other preferred programs. {firstName} will not be considered for programs listed after the zoned program.`,
    description: 'advice for programs saving, zoned school, high school student',
    values: {
      firstName: 'Your child',
    },
  },
  schoolProgramToolTipZonedMiddleSchool: {
    id: 'schoolProgram.ToolTipZoned.MiddleSchool',
    defaultMessage: `{firstName} has priority for this zoned program. Rank this program after other programs you prefer. {firstName} will still have a priority for this program if they don’t match to a choice that’s ranked higher.`,
    description: 'advice for programs saving, zoned school, middle school student',
    values: {
      firstName: 'Your child',
    },
  },
  schoolProgramToolTipZonedK: {
    id: 'schoolProgram.ToolTipZoned.K',
    defaultMessage: `This is your zoned program. Your child will receive priority as a zoned applicant to this program.`,
    description: 'Kindergarten zoned tooltip',
  },
  schoolProgramEligibleInfo: {
    id: 'schoolProgram.eligibleInfo',
    defaultMessage: 'Eligible info for program: {programTitle}, school: {schoolName}',
    description: 'String used to describe eligible info icon',
  },
  schoolProgramNotEligibleInfo: {
    id: 'schoolProgram.notEligibleInfo',
    defaultMessage: 'Not eligible info for program: {programTitle}, school: {schoolName}',
    description: 'String used to describe not eligible info icon',
  },
  schoolProgramZonedProgramInfo: {
    id: 'schoolProgram.zonedProgramInfo',
    defaultMessage: 'Zoned program info: {programTitle}, for school: {schoolName}',
    description: 'String used to describe zoned program info icon',
  },
  schoolProgramCurrentSchoolIconMessage: {
    id: 'schoolProgram.CurrentSchoolIconMessage',
    defaultMessage:
      'This is your child’s current school. If this school guarantees offers to current students, you will see it marked on programs below. Applying to any will guarantee an offer.',
    description:
      'String description to tell student they are guaranteed an offer by applying to any program in this school',
  },
  schoolProgramCurrentSchoolIconMessageK: {
    id: 'schoolProgram.CurrentSchoolIconMessageK',
    defaultMessage:
      'This is your child’s current school. Your child will receive priority to all programs at this school as a current student.',
    description: 'String description to tell student this is their current school',
  },
  schoolProgramCurrentSchoolInfo: {
    id: 'schoolProgram.currentSchoolInfo',
    defaultMessage: 'Current school program info: {programTitle}, for school: {schoolName}',
    description: 'String used to describe current school info icon',
  },
  currentSchoolStatusPendingMessage: {
    id: 'currentSchoolStatus.pendingMessage',
    defaultMessage: `Pending Verification.`,
    description: 'Current school claim verification pending status',
  },
  generalStringSignUp: {
    id: 'generalString.SignUp',
    defaultMessage: 'Sign Up',
    description: 'Label for sign up button',
  },
  generalStringClose: {
    id: 'generalString.Close',
    defaultMessage: 'Close',
    description: 'Label for close button.',
  },
  generalStringLogInHere: {
    id: 'generalString.LogInHere',
    defaultMessage: 'Log in here',
    description: 'Label for the login link',
  },
  generalStringGoToDashboard: {
    id: 'generalString.GoToDashboard',
    defaultMessage: 'Go to Dashboard',
    description: 'Label for the dashboard link',
  },
  generalStringExistingAccount: {
    id: 'generalString.ExistingAccount',
    defaultMessage: 'Already have an account?',
    description: 'Label asking user if they have an existing account.',
  },
  generalStringClearAddress: {
    id: 'generalString.ClearAddress',
    defaultMessage: 'Clear Address',
    description: 'Label for clearing address for logged out user.',
  },
  learnMoreLink: {
    id: 'learnMoreLink',
    defaultMessage: 'Learn more.',
    description: 'Learn more link.',
  },
  opensInNewWindow: {
    id: 'opensInNewWindow',
    defaultMessage: `opens in new window.`,
    description: 'Accessibility info message for links than open in a new window.',
  },
  searchAndFilterReset: {
    id: 'searchAndFilter.reset',
    defaultMessage: 'Reset',
    description: 'Reset label',
  },
  searchAndFilterApply: {
    id: 'searchAndFilter.apply',
    defaultMessage: 'Apply',
    description: 'Apply Label',
  },
  searchAndFilterSearchAndFilter: {
    id: 'searchAndFilter.searchAndFilter',
    defaultMessage: 'Search & Filter',
    description: 'Search and Filter Label',
  },
  searchAndFilterToggleAriaLabel: {
    id: 'searchAndFilter.toggleAriaLabel',
    defaultMessage: 'Toggle Search and Filter functionality',
    description: 'Aria label for Search and Filter toggle button on mobile',
  },
  searchAndFilterToggleMapAriaLabel: {
    id: 'searchAndFilter.toggleMapAriaLabel',
    defaultMessage: 'Toggle Map and Schools view',
    description: 'Aria label for Search and Filter toggle map button on mobile',
  },
  programScheduleFurtherActionTitle: {
    id: 'schedule.ProgramScheduleFurtherActionTitle',
    defaultMessage: 'Further action is needed before you can cancel',
    description: 'The program schedule further action title',
  },
  programScheduleFurtherAction: {
    id: 'schedule.ProgramScheduleFurtherAction',
    defaultMessage:
      'This program is currently on your application. To cancel your interest in this program, please ' +
      'remove it from your application first, and then you will be able to cancel.',
    description: 'The program schedule further action text',
  },
  goToApplicationsButton: {
    id: 'schedule.GoToApplicationsButton',
    defaultMessage: 'Go to my application',
    description: 'The program schedule further action button',
  },
  schoolProgramNotEligibleFirstParagraph: {
    id: 'schoolProgram.NotEligibleFirstParagraph',
    defaultMessage: `{firstName} is not eligible for this program. Open the program's details for eligibility info.`,
    description: 'advice for programs saving',
    values: {
      firstName: 'Your',
    },
  },
  schoolProgramNotEligibleSecondParagraph: {
    id: 'schoolProgram.NotEligibleSecondParagraph',
    defaultMessage: `If you believe this is an error, visit the Help section for contact information.`,
    description: 'advice for programs saving',
  },
  buttonSchedulingComplete: {
    id: 'button.label.schedulingComplete',
    defaultMessage: 'Mark scheduling as complete',
    description: 'Marks scheduling as completed',
  },
  buttonSchedulingAlreadyCompleted: {
    id: 'button.label.schedulingAlreadyCompleted',
    defaultMessage: 'Scheduling was already completed',
    description: 'Scheduling was already completed',
  },
  generalStringProgramPriorityGroup: {
    id: 'generalString.programPriorityGroup',
    defaultMessage: 'Priority groups',
    description: 'which priority group belong to a program',
  },
  generalStringSortLabelSchools: {
    id: 'generalString.labelSchools',
    defaultMessage: `{count} schools`,
    description: 'Schools count',
    values: {
      count: 1,
    },
  },
  generalStringSortLabelMiddleSchools: {
    id: 'generalString.labelMiddleSchools',
    defaultMessage: `{count} eligible schools`,
    description: 'Middle schools count',
    values: {
      count: 1,
    },
  },
  generalStringSortLabelPreKindergartenProviders: {
    id: 'generalString.labelPreKindergartenProviders',
    defaultMessage: `{count} Pre-K Providers`,
    description: 'Pre-K providers count',
    values: {
      count: 1,
    },
  },
  generalStringSortLabel2KProviders: {
    id: 'generalString.label2KProviders',
    defaultMessage: `{count} 2-K Providers`,
    description: '2-K providers count',
    values: {
      count: 1,
    },
  },
  generalStringSortLabel3KProviders: {
    id: 'generalString.label3KProviders',
    defaultMessage: `{count} 3-K Providers`,
    description: '3-K providers count',
    values: {
      count: 1,
    },
  },
  generalStringEligibility: {
    id: 'generalString.eligibility',
    defaultMessage: 'Eligibility',
    description: 'String used for student eligibility',
  },
  generalStringYourGroup: {
    id: 'generalString.yourGroup',
    defaultMessage: 'Your group:',
    description: 'String used for student group',
  },
  generalStringAllSeatsFilled: {
    id: 'generalString.allSeatsFilled',
    defaultMessage: 'All Seats Filled',
    description: 'String used for all seats filled',
  },
  generalStringNotAllSeatsFilled: {
    id: 'generalString.notAllSeatsFilled',
    defaultMessage: 'Not All Seats Filled',
    description: 'String used for not all seats filled',
  },
  generalStringApplicationsPerSeat: {
    id: 'generalString.pplicationsPerSeat',
    defaultMessage: 'Applications Per Seat',
    description: 'String used for applications per seat',
  },
  generalStringSeats: {
    id: 'generalString.seats',
    defaultMessage: 'Seats',
    description: 'String used for seats',
  },
  generalStringApplicants: {
    id: 'generalString.applicants',
    defaultMessage: 'Applicants',
    description: 'String used for applicants',
  },
  generalStringSelectionCriteria: {
    id: 'generalString.selectionCriteria',
    defaultMessage: 'Selection Criteria',
    description: 'String used for selectionCriteria',
  },
  schoolProgramSelectionCriteriaDescription: {
    id: 'generalString.selectionCriteriaDescription',
    defaultMessage: 'As {name} program the school also considers factors:',
    description: 'String used for description of the selection criteria',
    values: {
      name: 'a screened',
    },
  },
  schoolProgramSelectionCriteriaDescription1: {
    id: 'generalString.selectionCriteriaDescription1',
    defaultMessage: 'This school considers the following factors:',
    description: 'String used for description of the selection criteria',
  },
  generalStringYes: {
    id: 'generalString.yes',
    defaultMessage: 'Yes',
    description: 'Yes',
  },
  generalStringNo: {
    id: 'generalString.no',
    defaultMessage: 'No',
    description: 'No',
  },
  generalStringAvailable: {
    id: 'generalString.available',
    defaultMessage: 'Available',
    description: 'String used for available',
  },
  generalStringNotAvailable: {
    id: 'generalString.notAvailable',
    defaultMessage: 'Not Available',
    description: 'String used for not available',
  },
  generalStringAdmissionsMethod: {
    id: 'generalString.admissionsMethod',
    defaultMessage: 'Admissions',
    description: 'String used for admissions method',
  },
  generalStringContactInformation: {
    id: 'generalString.contactInformation',
    defaultMessage: 'Contact Information',
    description: 'String used for contact information',
  },
  generalStringEligibilityDescription: {
    id: 'generalString.eligibilityDescription',
    defaultMessage: 'Eligibility Description',
    description: 'String used for eligibility description',
  },
  generalStringDemandLastYear: {
    id: 'generalString.demandLastYear',
    defaultMessage: 'Seats and Demand Last Year',
    description: 'String used for demand last year',
  },
  generalStringGeneralEducation: {
    id: 'generalString.generalEducation',
    defaultMessage: 'General Education',
    description: 'String used for general education',
  },
  generalStringStudentsWithDisabilities: {
    id: 'generalString.studentsWithDisabilities',
    defaultMessage: 'Students With Disabilities',
    description: 'String used for students with disabilities',
  },
  generalStringStudentsNoteText: {
    id:'generalString.StudentNoteText',
    defaultMessage: `<i><strong>NOTE:</strong> Every NYC public school is expected to welcome and serve students with disabilities according to their IEP (Individualized Education Program).</i>`,
    description: 'String used for displaying note text under swd section',
  },
  generalStringMyChances: {
    id: 'generalString.myChances',
    defaultMessage: 'My Chances',
    description: 'String used for my chances',
  },
  generalStringProgramInformation: {
    id: 'generalString.programInformation',
    defaultMessage: 'Program Information',
    description: 'String used for program information',
  },
  generalStringAdditionalInformation: {
    id: 'generalString.additionalInformation',
    defaultMessage: 'Additional Information',
    description: 'String used for additional information',
  },
  generalStringProgramCode: {
    id: 'generalString.programCode',
    defaultMessage: 'Program Code',
    description: 'String used for program code',
  },
  generalStringSeats10thGrade: {
    id: 'generalString.seats10thGrade',
    defaultMessage: 'Seats 10th Grade',
    description: 'String used for seats 10th grade',
  },
  generalStringInterestArea: {
    id: 'generalString.interestArea',
    defaultMessage: 'Interest Area',
    description: 'String used for interest area',
  },
  generalStringLoading: {
    id: 'generalString.Loading',
    defaultMessage: 'Loading',
    description: 'String used for initial loading on pages, if needed',
  },
  generalStringAddressAutocompleteErrorMessage: {
    id: 'generalString.AddressAutocompleteErrorMessage',
    defaultMessage: 'Please select a valid NYC address',
    description: 'String used if user selects an invalid address from autocomplete on the public directory',
  },
  generalStringRegisterLabel: {
    id: 'generalString.Register',
    defaultMessage: 'Register',
    description: 'String used to label Register action',
  },
  preferencesTitle: {
    id: 'schoolprograminfo.preferences.title',
    defaultMessage: 'Preference is given to the following students',
    description: 'which students preference is given to',
  },
  schoolProgramLimitedUnscreened: {
    id: 'schoolProgram.LimitedUnscreened',
    defaultMessage:
      'This program includes priorities for students who sign in at an event. Find event info in the school’s details above, and determine your group from the list of Admission Priorities below.',
    description: 'String representing messaging for priority group for Limited Unscreened programs',
  },
  schoolProgramLimitedUnscreenedTooltip: {
    id: 'schoolProgram.LimitedUnscreenedTooltip',
    defaultMessage: 'This program includes priorities for students who sign in at an event. See program details.',
    description: 'String representing the tooltip for priority group for Limited Unscreened programs',
  },
  generalStringHighSchool: {
    id: 'generalString.HighSchool',
    defaultMessage: 'High School',
    description: 'String used for High School',
  },
  generalStringMiddleSchool: {
    id: 'generalString.MiddleSchool',
    defaultMessage: 'Middle School',
    description: 'String used for Middle School',
  },
  generalStringKindergarten: {
    id: 'generalString.Kindergarten',
    defaultMessage: 'Kindergarten',
    description: 'String used for Kindergarten',
  },
  generalStringPreK: {
    id: 'generalString.PreK',
    defaultMessage: 'Pre-K',
    description: 'String used for Pre-K',
  },
  generalString2K: {
    id: 'generalString.2K',
    defaultMessage: 'Birth to 2-Years-Old',
    description: 'String used for 2-K',
  },
  generalString3K: {
    id: 'generalString.3K',
    defaultMessage: 'Birth to 3-Years-Old',
    description: 'String used for 3-K',
  },
  generalStringGiftedTalented: {
    id: 'generalString.GiftedTalented',
    defaultMessage: 'Gifted & Talented',
    description: 'String used for Gifted Talented',
  },
  diversityInAdmissions: {
    id: 'directoryProgram.diversityInAdmissions',
    defaultMessage: 'Diversity In Admissions',
    description: 'String used for diversityInAdmissions',
  },
  diversityInAdmissionsDescription: {
    id: 'directoryProgram.diversityInAdmissionsDescription',
    defaultMessage: 'This school has a Diversity in Admissions Initiative.',
    description: 'String used for diversityInAdmissionsDescription',
  },
  loginAlertForAffiliatedSchoolsMessage: {
    id: 'home.loginAlertForAffiliatedSchoolsMessage',
    defaultMessage:
      "Please login and create a Summer Rising application to view your child's affiliated school.",
    description: 'Login for Affiliated Schools Alert Message',
  },
  loginAlertForAllSchoolsMessage: {
    id: 'home.loginAlertForAllSchoolsMessage',
    defaultMessage: 'You’re currently viewing the public directory. To view or manage your child’s applications, please log in to MySchools.',
    description: 'Login for All Schools Alert Message',
  },
  artCourses: {
    id: 'schoolinfo.artCourses',
    defaultMessage: 'ART COURSES',
    description: 'ART COURSES',
  },
  expressdInterestSaturdaySundayOptionSAT: {
    id: 'generalString.expressdInterestSaturdaySundayOptionSAT',
    defaultMessage: 'Student cannot test on Saturdays',
    description: 'Student cannot test on Saturdays',
  },
  expressdInterestSaturdaySundayOptionSUN: {
    id: 'generalString.expressdInterestSaturdaySundayOptionSUN',
    defaultMessage: 'Student cannot test on Sundays',
    description: 'Student cannot test on Sundays',
  },
  expressdInterestSaturdaySundayOptionLUN: {
    id: 'generalString.expressdInterestSaturdaySundayOptionLUN',
    defaultMessage: 'Student cannot test on Lunar New Year',
    description: 'Student cannot test on Lunar New Year',
  },
  expressdInterestSaturdaySundayOptionNL: {
    id: 'generalString.expressdInterestSaturdaySundayOptionNL',
    defaultMessage: 'Student can test on either day',
    description: 'Student can test on either day',
  },
});

export const CoachmarksSearch = defineMessages({
  stepOneParagraphOne: {
    id: 'coachmarks.Search.Step.One.P1',
    defaultMessage:
      '<p>Before you start exploring schools, a few tips:<br />Use this menu bar to move through the application at your own pace. Just be sure to submit your application (Apply) before the deadline!</p>',
    description: 'Coachmarks search step one P1',
  },
  stepOneParagraphTwo: {
    id: 'coachmarks.Search.Step.One.P2',
    defaultMessage:
      'Return to Overview at any time to view your checklist and track your progress. Later steps are also available, but focus on Search for now!',
    description: 'Coachmarks search step one P2',
  },
  stepTwoParagraphOne: {
    id: 'coachmarks.Search.Step.Two.P1',
    defaultMessage:
      '<p>Before you start exploring schools, a few tips!</p>',
    description: 'Coachmarks search step two P1',
  },
  stepTwoParagraphTwo: {
    id: 'coachmarks.Search.Step.Two.P2',
    defaultMessage:
      '<p>Students actually apply to programs at schools. Each school card also lists programs at that school.</p>',
    description: 'Coachmarks search step two P2',
  },
  stepThreeParagraphOne: {
    id: 'coachmarks.Search.Step.Three.P1',
    defaultMessage:
      '<p>Think of a program (like this one) as a doorway to get into the school. Tap or click on programs to learn about them.</p>',
    description: 'Coachmarks search step three P1',
  },
  stepThreeParagraphTwo: {
    id: 'coachmarks.Search.Step.Three.P2',
    defaultMessage:
      '<p>You can apply to multiple programs at a school, if you’re interested in more than one. Some schools have programs that focus on certain interests or areas of study, and some schools have programs that reflect the whole school’s offerings.</p>',
    description: 'Coachmarks search step three P2',
  },
  stepFourParagraphOne: {
    id: 'coachmarks.Search.Step.Four.ParagraphOne',
    defaultMessage: '<p>How to decide? There are a lot of programs, and a lot of information about each.</p>',
    description: 'Coachmarks search step four paragraph one',
  },
  stepFourParagraphTwo: {
    id: 'coachmarks.Search.Step.Four.ParagraphTwo',
    defaultMessage:
      '<p>Many families consider the daily commute and the school’s location to be important factors. Use the map to see a school’s location and the distance from your child’s home.</p>',
    description: 'Coachmarks search step four paragraph two',
  },
  stepFiveParagraphOne: {
    id: 'coachmarks.Search.Step.Five.ParagraphOne',
    defaultMessage:
      '<p>How to decide? Use the filters below the search bar to see only schools that meet certain criteria. From More Filters, select the Eligible filter to only see schools you can list on your application!</p>',
    description: 'Coachmarks search step five paragraph one',
  },
  stepFiveParagraphTwo: {
    id: 'coachmarks.Search.Step.Five.ParagraphTwo',
    defaultMessage:
      '<p>Find information on criteria like academic performance, sports, and activities by selecting a school or program.</p>',
    description: 'Coachmarks search step five paragraph two',
  },
  stepSix: {
    id: 'coachmarks.Search.Step.Six',
    defaultMessage:
      '<p>When you find a program you like, click the star to add it to your favorites.</p><p>You can view your list of your favorite programs on the apply page.</p>',
    description: 'Coachmarks search step six',
  },
  stepSeven: {
    id: 'coachmarks.Search.Step.Seven',
    defaultMessage:
      'Want to better understand your child’s chances of getting an offer to each program? Hover or tap these icons to learn about the program’s demand and find out your child’s priority group. These icons will not display if your child is not eligible for the program, or if the program is their guaranteed program. Click or tap on the program for more details.',
    description: 'Coachmarks search step seven',
  },
  stepEight: {
    id: 'coachmarks.Search.Step.Eight',
    defaultMessage:
      'You’re ready to start exploring programs!',
    description: 'Coachmarks search step eight',
  },
});

export const CoachmarksSaved = defineMessages({
  stepOne: {
    id: 'coachmarks.Saved.Step.One',
    defaultMessage:
      '<p>Your saved programs are listed on this page. Use this page to consider the ones you’re interested in applying to in more detail.</p><p>You can search and filter your Saved programs, just like on the Search page.</p>',
    description: 'Coachmarks saved step one',
  },
  stepTwoParagraphOne: {
    id: 'coachmarks.Saved.Step.Two.ParagraphOne',
    defaultMessage:
      '<p>You can also view school and program details, like on the Search page. If you decide you’re no longer interested in a program, you can unsave it by tapping or clicking on the star.</p>',
    description: 'Coachmarks saved step two paragraph one',
  },
  stepTwoParagraphTwo: {
    id: 'coachmarks.Saved.Step.Two.ParagraphTwo',
    defaultMessage:
      '<p>Unlike on Search, if you save multiple programs from a single school, each program appears on a separate school card.</p>',
    description: 'Coachmarks saved step two paragraph two',
  },
  stepThree: {
    id: 'coachmarks.Saved.Step.Three',
    defaultMessage:
      'You can choose to order saved programs with the most recently saved ones at the top or by their distance from your child’s home.',
    description: 'Coachmarks saved step three',
  },
  stepFourParagraphOne: {
    id: 'coachmarks.Saved.Step.Four.ParagraphOne',
    defaultMessage:
      '<p>Try saving at least 25 programs! If you’ve saved fewer, you’ll see a reminder above your list.</p>',
    description: 'Coachmarks saved step four paragraph one',
  },
  stepFourParagraphTwo: {
    id: 'coachmarks.Saved.Step.Four.ParagraphTwo',
    defaultMessage:
      '<p>You can return to Search to find more programs to save, and then back to Saved to view just the ones you’re considering.</p>',
    description: 'Coachmarks saved step four paragraph two',
  },
});

export const CoachmarksSchedule = defineMessages({
  stepOneParagraphOne: {
    id: 'coachmarks.Schedule.Step.One.ParagraphOne',
    defaultMessage:
      '<p>Programs you’ve added to favorites that require an assessment for admission (for example, an audition, test, interview, etc.) are listed on this page.</p>',
    description: 'Coachmarks schedule step one paragraph one',
  },
  stepOneParagraphTwo: {
    id: 'coachmarks.Schedule.Step.One.ParagraphTwo',
    defaultMessage:
      '<p>While you can submit your application before you’ve done a program’s assessment, you must at least schedule it or express your interest before you can add the program to your application. You’ll do that here.</p>',
    description: 'Coachmarks schedule step one paragraph two',
  },
  stepTwo: {
    id: 'coachmarks.Schedule.Step.Two',
    defaultMessage:
      '<p>If you have yet to schedule a program’s assessment or express your interest, you can do so here.</p><p>Tap or click this button and follow the steps to complete the request.</p><p>The school may contact you to schedule (or reschedule if necessary) a time for your assessment.</p>',
    description: 'Coachmarks schedule step two',
  },
  stepThreeParagraphOne: {
    id: 'coachmarks.Schedule.Step.Three.ParagraphOne',
    defaultMessage:
      '<p>Check your Scheduled list to review any programs you’ve scheduled assessments for, or expressed interest in.</p>',
    description: 'Coachmarks schedule step three paragraph one',
  },
  stepThreeParagraphTwo: {
    id: 'coachmarks.Schedule.Step.Three.ParagraphTwo',
    defaultMessage:
      '<p>You can return here at any time to find dates, time, and locations for assessments you scheduled online. If you express interest and the school then contacts you to schedule, be sure to keep track of that appointment yourself!</p>',
    description: 'Coachmarks schedule step three paragraph two',
  },
  stepFour: {
    id: 'coachmarks.Schedule.Step.Four',
    defaultMessage:
      'Remember, just because a program you’ve added to favorites is shown on this page does not mean you have to schedule an assessment for it — only if you definitely want to apply to it!',
    description: 'Coachmarks schedule step four',
  },
});

export const CoachmarksApply = defineMessages({
  stepOneParagraphOne: {
    id: 'coachmarks.Apply.Step.One.ParagraphOne',
    defaultMessage: '<p>On this page, you’ll build your application — and eventually submit it!</p>',
    description: 'Coachmarks apply step one paragraph one',
  },
  stepOneParagraphOneSR: {
    id: 'coachmarks.Apply.SR.Step.One.ParagraphOne',
    defaultMessage: '<p>We automatically placed your affiliated programs in the favorites section if you have one.</p>',
    description: 'Coachmarks apply step one paragraph one for SR',
  },
  stepOneParagraphTwo: {
    id: 'coachmarks.Apply.Step.One.ParagraphTwo',
    defaultMessage:
      '<p>If you’ve added programs to your favorites, you’ll find them here and can add them to your application. You can always remove programs and re-submit your application (until the deadline), so feel free to try adding some.</p>',
    description: 'Coachmarks apply step one paragraph two',
  },
  stepOneParagraphThree: {
    id: 'coachmarks.Apply.Step.One.ParagraphThree',
    defaultMessage:
      '<p>You may not be able to add some programs if you’re not eligible, or if you need to schedule an assessment first. Find that information next to each program.</p>',
    description: 'Coachmarks apply step one paragraphTh three',
  },
  stepTwoParagraphOne: {
    id: 'coachmarks.Apply.Step.Two.ParagraphOne',
    defaultMessage:
      '<p>View “Your Application” to see the programs you’ve added to your application, or to search for and add any program directly.</p>',
    description: 'Coachmarks apply step two paragraph One',
  },
  stepTwoParagraphTwo: {
    id: 'coachmarks.Apply.Step.Two.ParagraphTwo',
    defaultMessage:
      '<p>Drag and drop programs to reorder them. Click on programs in the list to view details in order to make final decisions about how to order your list.</p>',
    description: 'Coachmarks apply step two paragraph Two',
  },
  stepTwoParagraphThree: {
    id: 'coachmarks.Apply.Step.Two.ParagraphThree',
    defaultMessage: '<p>It’s important to list programs in your true order of preference. Order matters!</p>',
    description: 'Coachmarks apply step two paragraph Three',
  },
  stepThree: {
    id: 'coachmarks.Apply.Step.Three',
    defaultMessage:
      'It’s important to apply to {maxPrograms} programs! Once you’ve filled up your list, you can prepare to submit it (during the application period) by clicking the button at the bottom of your application.',
    description: 'Coachmarks apply step three',
  },
});
